var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('b-form-input',{attrs:{"type":"number","lazy":"","placeholder":_vm.$t('enter-number'),"min":_vm.getMin,"max":_vm.getMax,"step":_vm.interval,"state":_vm.isValid ? null : false,"disabled":!_vm.isConnectionOk},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }